import PropTypes from 'prop-types';
import React from 'react';

const InstagramAuthRedirect = ({ confirm }) => (
  <div className="c-inner-wrapper u-max-width-400 u-position-relative u-mt+ large-and-up-mt++">
    {confirm ? (
      <span>
        Your Instagram account has been successfully linked to Squire.
        <br />
        <br />
        <span className="u-type--bold">
          Don’t forget to tag the pictures you’d like to showcase on Squire with the #getSquire hashtag.
        </span>
      </span>
    ) : (
      'Something went wrong. We could not confirm that Instagram was linked successfully.'
    )}
  </div>
);

InstagramAuthRedirect.propTypes = {
  confirm: PropTypes.bool.isRequired,
};
InstagramAuthRedirect.defaultProps = {};

export default InstagramAuthRedirect;

